<template>
    <div class="member-auth">
        <div class="common-header-wrap">
            <mt-header title="保险购买" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.push({ name: 'MemberIndex' })"></mt-button>
            </mt-header>
            <div class="goodslist-body show-goods-list" >
                <!-- 无限加载滚动列表 -->
                <div class="flex-wrapper">
                    <div class="ui-product-body"
                         v-for='(item, index) in list'
                         v-bind:key='index'
                    >
                        <div class="list">
                            <div class="ui-image-wrapper" @click="goDetail(item)">
                                <img class="product-img" v-lazy="item.img">
                            </div>
                            <div class="flex-right">
                                <div class="product-header" @click="goDetail(item)">
                                    <h3 class="title clear-bottom" style="-webkit-box-orient:vertical">{{ item.name }}</h3>
                                </div>
                                <div class="p-price" style="-webkit-box-orient:vertical">
                                    ¥{{ item.price }} <span style="color: #999;font-size: 0.5rem;" class="goods_salenum">有效期购买后{{item.limited}}个月</span>
                                </div>
                                <div class="p-info">
                                    <span class="goods_salenum">状态: <span v-if="item.pay_status==1">已购买</span><span v-else>未购买</span></span>
                                    <span class="goods_salenum" v-if="item.pay_status==1">有效期:{{item.endtime}}</span>
                                </div>
                                <div class="add-cart" v-if="item.pay_status==0"><mt-button type="danger" size="small"  @click="confirmSumit(item)">购买</mt-button></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>
<script>
    import { getInsurance } from '../../../api/member'
    import { Toast } from 'mint-ui'
    import { mapState } from 'vuex'
    export default {
        name: 'pay',
        data () {
            return {
                list: [],
            }
        },
        computed: {
            ...mapState({
                token: state => state.member.token
            })
        },
        created: function () {
            getInsurance().then(res => {
                this.list = res.result
            }).catch(function (error) {
                Toast(error.message)
            })
        },
        methods: {
            goDetail (item) {
                this.$router.push({ 'name': 'InsuranceDetail', 'query': { 'id': item.id } })
            },
            confirmSumit (item) {
                this.$router.push({ name: 'MemberInsurance', query: { id: item.id } })
            }
        }
    }
</script>
<style  lang="scss" scoped>
    .goodslist-body{
        padding-top: 2rem;
    }
    .mint-button--small {
        display: inline-block;
        font-size: 10px;
        padding: 0 3px;
        height: 1.4rem;
        line-height: 1.4rem;
    }
    .ui-product-body {
        border-bottom: .045rem solid rgba(232,234,237,1);
        .list {
            display: flex;
            width: auto;
            align-items: center;
            justify-content: space-between;
            margin: .5rem .45rem;
            position: relative;
            div.ui-image-wrapper {
                width: 5rem;
                height: 5rem;
                position: relative;
                display: flex;
                justify-content: center;
                align-content: center;
                align-items: center;
                flex-basis: 5rem;
                flex-shrink: 0;
                background-position:center center!important;
                background-size:4.54rem 4.54rem;
                background-repeat:no-repeat;
                -webkit-background-size: cover;
                -moz-background-size: cover;
                -o-background-size: cover;
                background-size: cover;

                img.product-img{
                    width: 5rem;
                    height: 5rem;
                    flex-basis: 5rem;
                    flex-shrink: 0;
                }
                img.product-img[lazy=loading] {
                    width: 1.36rem;
                    height: 1.36rem;
                }
                img.product-im[lazy=error] {
                    width: 1.36rem;
                    height: 1.36rem;
                }
                img.product-img[lazy=loaded] {
                    width: 100%;
                    height: auto;
                    flex-basis: 5rem;
                    flex-shrink: 0;
                    background:rgba(255,255,255,1);
                }
                span {
                    position: absolute;
                    height:.9rem;
                    background:rgba(243,244,245,1);
                    line-height: .9rem;
                    text-align: center;
                    font-size:.63rem;
                    color:$primaryColor;
                    width: 5rem;
                    bottom: 0;
                    left: 0;
                }
            }
            .flex-right {
                padding-left: .63rem;
                width: 100%;
                position:relative;
                .title {
                    color: #333;
                    font-size: .6rem;
                    line-height:1rem;
                    height:2rem;
                    font-weight: normal;
                    overflow: hidden;
                    margin-bottom: .36rem;
                    &.clear-bottom {
                        margin-bottom: 0;
                    }
                }
                .product-header {
                    margin-bottom: .5rem;
                    display: flex;
                    align-items: center;
                }
                .p-price {
                    color: #e93b3d;
                    font-size:0.7rem;
                }
                .p-info {
                    margin-bottom: .36rem;
                    .platform_store{font-size:.5rem;color: #e93b3d;border: .045rem solid #e93b3d;border-radius: .13rem;padding:0 .2rem;}
                    .goods_salenum{font-size:.5rem;color:#999;margin-right: 0.3rem}
                }
                .add-cart{
                    background: #e93b3d;text-align:center;position: absolute;right: .8rem;bottom:.2rem;width:1.6rem;height:1.4rem;line-height:1.4rem;
                    i{font-size:0.8rem;color:#fff;display:block;}
                }
            }
        }
    }
</style>
